module.exports = __webpack_public_path__ + "img/1.c7940cc4.png";